import { LOCK_WSPOS, LOCK_WSPOS_SUCCESSFUL, LOCK_WSPOS_FAILED } from './actionTypes';

const initialState = {
    lockWSPositionError: null, messageUnlockWSPosition: null, loadingUnlockWSPosition: false
}

const lockWSPosition = (state = initialState, action) => {
    switch (action.type) {
        case LOCK_WSPOS:
            state = {
                ...state,
                loadingUnlockWSPosition: true,
                lockWSPositionError: null
            }
            break;
        case LOCK_WSPOS_SUCCESSFUL:
            state = {
                ...state,
                loadingUnlockWSPosition: false,
                messageUnlockWSPosition: action.payload,
                lockWSPositionError: null
            }
            break;
        case LOCK_WSPOS_FAILED:
            state = {
                ...state,
                messageUnlockWSPosition: null,
                loadingUnlockWSPosition: false,
                lockWSPositionError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default lockWSPosition;